import type { TruckStatus } from '@chukua/common';

/** Tag colour and label for a truck's status — driven entirely by domain events (gitaumoses4/chukua#19), never editable here. */
export const TRUCK_STATUS_LABELS: Record<TruckStatus, string> = {
  available: 'Available',
  on_trip: 'On trip',
  in_yard: 'In yard',
  in_workshop: 'In workshop',
  off_road: 'Off-road',
};

export const TRUCK_STATUS_COLORS: Record<TruckStatus, string> = {
  available: 'success',
  on_trip: 'processing',
  in_yard: 'default',
  in_workshop: 'warning',
  off_road: 'error',
};
